import { storyblokEditable } from '@storyblok/react/rsc'
import { clsx } from 'clsx'
import { type FC } from 'react'

import { type StoryblokComponentProps } from '../../model'
import { type StoryblokHeaderBannerType } from '../../model/storyblokTypes.generated'
import { useCmsRichTextRender } from '../../useCmsRichTextRender'
import { StoryblokComponentsRenderer } from '../StoryblokComponentsRenderer'
import { StoryblokImageComponentHelper } from '../StoryblokImageComponentHelper'

export const StoryblokHeaderBanner: FC<
  StoryblokComponentProps<StoryblokHeaderBannerType>
> = ({ blok }) => {
  const cmsRenderRichText = useCmsRichTextRender()

  return (
    <div
      {...storyblokEditable(blok)}
      className={clsx(
        'flex w-full max-w-5xl flex-col items-center justify-center bg-inherit tablet:flex-row',
        blok.addVerticalSpacing && 'tablet:py-8',
      )}
    >
      <div className="tablet:mr-10 tablet:w-1/2">
        <StoryblokImageComponentHelper
          className="mr-0 tablet:-mr-10 tablet:rounded-2xl"
          height={500}
          image={blok.image}
          priority
          width={900}
        />
      </div>
      <div
        className={clsx(
          '-mt-6 flex flex-col gap-6 rounded-t-2xl px-6 py-8 tablet:mt-0 tablet:w-1/2 tablet:rounded-none tablet:bg-inherit tablet:p-0',
          blok.contentBackgroundOnMobile === 'now' && 'bg-light-brand-low',
          blok.contentBackgroundOnMobile === 'white' && 'bg-light-primary-low',
          blok.contentBackgroundOnMobile === 'light' &&
            'bg-light-primary-medium',
        )}
      >
        {blok.title ? (
          <div className="prose text-2xl tablet:text-3xl">
            {cmsRenderRichText(blok.title)}
          </div>
        ) : null}
        <div className="flex flex-col gap-7 tablet:flex-row tablet:items-center">
          <StoryblokComponentsRenderer bloks={blok.content} />
        </div>
      </div>
    </div>
  )
}
